// crewbit-admin/src/components/money/EmptyExpensesState.tsx
//
// Calm-empty for /money/expenses when the tenant has zero expenses on file.
// CTA opens MoneyExpenseLogPanel via the parent's `?action=log` URL state.
// Spec: docs/references/MONEY_MODULE_SPEC_v1.md §Expenses.7.2.

import { Receipt } from 'lucide-react';
import { palette, admin, radii, spacing } from '../../styles/tokens';

interface EmptyExpensesStateProps {
  onLogFirstExpense: () => void;
}

export function EmptyExpensesState({ onLogFirstExpense }: EmptyExpensesStateProps) {
  return (
    <div
      style={{
        background: palette.white,
        border: `1px solid ${admin.border}`,
        borderRadius: admin.cardRadius,
        padding: '64px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: radii.full,
          background: palette.accentWash,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: palette.accent,
          marginBottom: spacing.md,
        }}
      >
        <Receipt size={24} strokeWidth={1.75} />
      </div>
      <div style={{ fontSize: 17, fontWeight: 600, color: admin.header }}>
        No expenses logged yet
      </div>
      <div
        style={{
          fontSize: 13,
          color: admin.caption,
          lineHeight: 1.55,
          maxWidth: 360,
          marginTop: spacing.sm,
        }}
      >
        Log your first business expense to start building T2125-ready records for tax time.
      </div>
      <button
        type="button"
        onClick={onLogFirstExpense}
        style={{
          marginTop: spacing.lg,
          padding: '10px 22px',
          borderRadius: radii.sm,
          background: palette.accent,
          color: palette.white,
          border: 'none',
          fontSize: 13,
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        Log first expense
      </button>
    </div>
  );
}
